import { useQuery } from 'react-query';
import { useCognitoUserContextWithUser } from 'domains/auth/AWSCognitoWrapper/context';
import { getAssociatedClientsAndData, getContact } from 'domains/contact/queries';
import { useUserClientsLoggedIn } from 'domains/auth/UserClientsWrapper/useUserClients';

export const useContactAndClients = (config?: { onError: (err: unknown) => void; useErrorBoundary?: boolean }) => {
  const { onError, useErrorBoundary } = config ?? {};
  const { user } = useCognitoUserContextWithUser();

  return useQuery(['contact-data', user.username], () => getAssociatedClientsAndData(user.username), {
    retry: 2,
    useErrorBoundary,
    onError,
  });
};

export const useContact = () => {
  const { contactId } = useUserClientsLoggedIn();

  return useQuery(['contact', contactId], () => getContact(contactId));
};
